export const roundPriceAmount = (amount: number) => {
  return Math.ceil(amount / 100);
};
